import { render, staticRenderFns } from "./JSelectSort.vue?vue&type=template&id=0639a4aa&"
import script from "./JSelectSort.vue?vue&type=script&lang=js&"
export * from "./JSelectSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0639a4aa')) {
      api.createRecord('0639a4aa', component.options)
    } else {
      api.reload('0639a4aa', component.options)
    }
    module.hot.accept("./JSelectSort.vue?vue&type=template&id=0639a4aa&", function () {
      api.rerender('0639a4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/JSelectBizComponent/JSelectSort.vue"
export default component.exports